import React from "react";
import { ArrowDown, ArrowRight, FileSpreadsheet, FileJson, Files, GitMerge } from "lucide-react";

const sources = [
  { title: "CRO deliveries", detail: "Results · units · revisions", Icon: Files },
  { title: "Instrument exports", detail: "Readouts · plates · samples", Icon: FileSpreadsheet },
  { title: "Experiment records", detail: "Conditions · methods · metadata", Icon: FileJson },
];

const ScientificDataVisual = () => (
  <figure className="solutions-data-visual" aria-labelledby="data-visual-title">
    <figcaption id="data-visual-title">From delivered files to a reusable dataset</figcaption>
    <div className="solutions-data-flow">
      <div className="solutions-data-sources">
        {sources.map(({ title, detail, Icon }) => (
          <div className="solutions-data-source" key={title}>
            <Icon aria-hidden="true" />
            <div><strong>{title}</strong><span>{detail}</span></div>
          </div>
        ))}
      </div>
      <div className="solutions-data-connector" aria-hidden="true"><ArrowRight /><ArrowDown /></div>
      <div className="solutions-data-transform">
        <GitMerge aria-hidden="true" />
        <h3>Connect the records.</h3>
        <p>Match samples.<br />Reconcile units.<br />Keep the source.</p>
        <span>Conflicts go to scientist review.</span>
      </div>
      <div className="solutions-data-connector" aria-hidden="true"><ArrowRight /><ArrowDown /></div>
      <div className="solutions-data-output">
        <div className="solutions-data-table" aria-hidden="true">
          {["Sample", "Result", "Unit", "Source"].map((column) => <span key={column}>{column}</span>)}
          {Array.from({ length: 12 }, (_, index) => <i key={index} />)}
        </div>
        <h3>One traceable dataset.</h3>
        <p>Ready for analysis.<br />Ready for the next delivery.</p>
      </div>
    </div>
    <p className="solutions-data-caption">Illustrative data workflow. Original records stay linked to the transformed data.</p>
  </figure>
);

export default ScientificDataVisual;
